<template>
  <div class="loading">
    <van-loading class="loading-content" type="spinner" size="30px" color="#ffffff" vertical>加载中...</van-loading>
  </div>
</template>
 
<script>
export default {
  name: 'LOADING',
  data() {
    return {};
  }
};
</script>
<style lang="less" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  .loading-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>